var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Head'),_c('div',{staticClass:"layout"},[(_vm.isAlive)?_c('router-view'):_vm._e()],1),_c('Foot'),_c('BackTop',{attrs:{"height":100,"bottom":100}},[_c('div',{staticClass:"up"},[_c('i',{staticClass:"iconfont icon-shang"}),_c('br'),_vm._v(" TOP")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }